import { SearchType } from '~/components/field/common/search-definition';

/**
 * This should correspond to the Java map au.com.finsyn.acuritywebserver.core.dao.DaoUtils#ADVANCED_SEARCH_MAP
 */
export enum AdvancedSearchInputType {
	// Member
	SURNAME = 'surname',
	GIVEN_NAMES = 'given-names',
	MIDDLE_NAMES = 'middle-names',
	FUND = 'fund',
	MEMBER = 'member',
	CLIENT = 'client',
	CUSTOMER_NUMBER = 'customer-number',
	DATE_OF_BIRTH = 'date-of-birth',
	CATEGORY = 'category',
	MEMBER_EMPLOYER = 'member-employer',
	STATUS = 'status',
	TFN = 'tfn',

	// Employer
	PAYROLL_FUND = 'payroll-fund',
	EMPLOYER = 'employer',
	PAYROLL_NAME = 'payroll-name',
	TRADING_NAME = 'trading-name',
	INSTITUTION_TYPE = 'institution-type',
	STATE = 'state',
	POSTCODE = 'postcode',
	ABN = 'abn',
	PAYROLL_TYPE = 'payroll-type',
}

export interface AdvancedSearchInputProps {
	name?: string;
	title: string;
	stateProp: string;
	fieldMaxLength?: number;
	firstInput?: boolean;
	onChangeProperty?: (value: string) => void;
}

export interface AdvancedSearchAutocompleteProps
	extends AdvancedSearchInputProps {
	searchType: SearchType;
	displayResultsOnFocus?: boolean;
	resultsDropUp?: boolean;
}
